module.exports = __webpack_public_path__ + "static/img/diet_02.aa067eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c14/diet_02.jpg
// module id = Yffl
// module chunks = 1